import { useEffect } from "react";
import { useSampleDataTableDispatch } from "../contexts/SampleDataTableContext";

export default function useGetSampleDataTables() {
  const sampledatatableDispatch = useSampleDataTableDispatch();

  useEffect(() => {
    sampledatatableDispatch({
      type: "setIsLoadingSampleDataTables",
      payload: true,
    });

    fetch("/api/sample-datatables")
      .then((response) => response.json())
      .then((r) => {
        sampledatatableDispatch({
          type: "setSampleDataTables",
          payload: r,
        });
        sampledatatableDispatch({
          type: "setIsLoadingSampleDataTables",
          payload: false,
        });
      });
  }, [sampledatatableDispatch]);
}
